export default __webpack_public_path__ + "static/media/24.5f5b6fc6.jpg";